export enum AuthClaim {
  CompanyId = 'https://claims.safarilaw.com/companyid',
  UserId = 'https://claims.safarilaw.com/userid',
  Email = 'email',
  ConnectionName = 'https://claims.safarilaw.com/auth0connection',
  EmailVerified = 'email_verified',
  Name = 'name',
  Nickname = 'nickname',
  Picture = 'picture'
}

export enum AuthFailedReason {
  Unknown,
  Deactivated,
  NoAccessToRequestedCompany,
  NoAccessToAnyCompany,
  InvalidState
}

export enum LogoutReason {
  Manual = '1',
  Inactivity = '2'
}

export interface LogoutParams {
  redirectPath?: string;
  reason?: LogoutReason | string;
}

/* DUPE: Safari_User_SelectedCompanyId */
export const STORAGE_AUTH_COMPANYID_KEY = 'Safari_User_SelectedCompanyId';
export const STORAGE_AUTH_TOKEN_EXPIRATION_KEY = 'Safari_Auth_TokenExpiration';
export const STORAGE_AUTH_INVALID_STATE_RETRY_COUNT = 'Safari_Auth_InvalidStateRetryCount';
export const STORAGE_AUTH_LAST_ACTIVITY_TIMESTAMP = 'Safari_Auth_LastActivityTimestamp';
// When this value is set, it indicates that at least one of the tabs has been logged out due to inactivity.
// All other listeners should then immediately log out.
// We need this extra indicator because navigation end updates last activity time, and
// logging out is necessarily a navigation event.
export const STORAGE_AUTH_LOGOUT_REASON = 'Safari_Auth_LogoutReason';

export const STORAGE_AUTH_WAS_ON = 'Safari_Auth_Logout_WasOn';
